module.exports = __webpack_public_path__ + "static/nutrition_bottom_bar-d80a7df7a5b7aa44391c8e175379bc87.png";